import type { Interaction } from '@/types';

/**
 * True iff the request identified by (conversationId, requestId) is the only
 * pending request left in the tree — answering it empties the roster, so the
 * credential drawer should hand off to the workflow drawer (ENG-3976). When
 * other requests remain, useAdvanceCredentialSelection advances the form in
 * place instead. (conversationId, requestId) identifies at most one interaction
 * (requestId is a fresh UUIDv7; key = #interaction#{conv}#{req}).
 */
export function isLastPendingRequest(
  pendingInteractions: Interaction[],
  conversationId: string,
  requestId: string
): boolean {
  return pendingInteractions.every(
    i => i.conversationId === conversationId && i.requestId === requestId
  );
}
